/**
 * i18n consumer hooks (#42, 2026-06-12).
 *
 * Split from `provider.tsx` so hooks fast-refresh independently from the
 * `I18nProvider` component (react-refresh/only-export-components) — the same
 * split as `use-session.ts` vs `auth-context.tsx`.
 *
 *   - `useTranslation()` → `{ t }`. Call `t('auth.signIn')` for a string. The
 *     key is checked + autocompleted against the `en` catalog's key union.
 *   - `useLocale()` → `{ locale, setLocale, loading }` for the language switcher.
 */

import { useContext } from 'react';
import { I18nContext } from './context';

/** Returns `{ t }` — the translate function bound to the active locale. */
export function useTranslation() {
  const { t } = useContext(I18nContext);
  return { t };
}

/** Returns `{ locale, setLocale, loading }` for the language switcher. */
export function useLocale() {
  const { locale, setLocale, loading } = useContext(I18nContext);
  return { locale, setLocale, loading };
}
